export enum ApplicationType {
  Group = 'GROUP',
  Ordinary = 'ORDINARY',
  NewYork = 'NY',
  Undefined = 'UNDEFINED',
  Empty = '',
}
